import cc from 'classcat';

import BaseResponsiveHeroImage from '#src/rows/ResponsiveHeroImage/index.js';

import styles from './ResponsiveHeroImage.scss';

export function ResponsiveHeroImage({ className, ...props }) {
  return (
    <BaseResponsiveHeroImage
      {...props}
      className={cc([className, styles.container])}
    />
  );
}
